import React, { useState } from 'react';
import ContactForm from './ContactForm';

const Tabs = () => {
  const [activeTab, setActiveTab] = useState('home');

  const HomeContent = () => (
    <div className="flex flex-col items-center justify-center max-w-3xl mx-auto">
      <header className="text-center mb-16 relative z-10">
        <div className="relative">
          <img 
            src="/logo-afw.png" 
            alt="Antique France Worldwide Logo" 
            className="mx-auto w-48 h-48 object-contain transform hover:scale-105 transition-transform duration-300 border-2 border-[#d4b084] rounded-full p-1" 
          />
          <div className="absolute inset-0 bg-[#d4b084] opacity-10 rounded-full blur-xl"></div>
        </div>
        <h1 className="mt-8 text-3xl md:text-5xl font-serif tracking-wider text-[#d4b084]">
          Objets du passé. Présents pour l'avenir.
        </h1>
      </header>
      
      <section className="text-center mb-16 relative z-10 px-4">
        <p className="text-xl md:text-2xl font-light leading-relaxed text-white/90 max-w-2xl mx-auto">
          Antique France Worldwide est une maison indépendante spécialisée dans les objets anciens, les curiosités, les arts oubliés et les traces précieuses du monde d'avant. Plus de 12 000 objets sélectionnés, restaurés, et proposés au monde entier via notre boutique.
        </p>
      </section>
      
      <a 
        href="https://www.ebay.fr/str/vintageclothin" 
        target="_blank" 
        rel="noopener noreferrer"
        className="bg-[#d4b084] text-black px-12 py-4 rounded-xl font-semibold text-xl transition-all duration-300 hover:bg-[#c19a6b] hover:shadow-lg hover:shadow-[#d4b084]/20 transform hover:-translate-y-1"
      >
        Voir la boutique eBay
      </a>
    </div>
  );

  return (
    <div className="w-full max-w-4xl mx-auto">
      <div className="flex justify-center space-x-4 mb-8">
        <button
          onClick={() => setActiveTab('home')}
          className={`px-6 py-2 rounded-lg font-medium transition-all duration-300 ${
            activeTab === 'home'
              ? 'bg-[#d4b084] text-black'
              : 'text-[#d4b084] hover:bg-[#d4b084]/10'
          }`}
        >
          Accueil
        </button>
        <button
          onClick={() => setActiveTab('contact')}
          className={`px-6 py-2 rounded-lg font-medium transition-all duration-300 ${
            activeTab === 'contact'
              ? 'bg-[#d4b084] text-black'
              : 'text-[#d4b084] hover:bg-[#d4b084]/10'
          }`}
        >
          Contact
        </button>
      </div>

      <div className="transition-all duration-300 transform">
        {activeTab === 'home' ? <HomeContent /> : <ContactForm />}
      </div>
    </div>
  );
};

export default Tabs; 